import React, { Component } from 'react';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger'
import { Provider } from 'react-redux';
import { reducer as FormReducer } from 'redux-form';
import { HashRouter, Route } from 'react-router-dom';
import logo from './image/verisk-nosavi_1x.svg';
//import 'core-js';

import 'font-awesome/css/font-awesome.min.css';

import './styles/index.css';

import StartQuoteReducer from './StartQuote/reducers';
import ConfirmationReducer from './Confirm/reducer';
import ReviewReducer from './Review/reducers';
import sectionTitleReducer from './SectionTitle/reducers';
import LoadingReducer from './LoadingComponent/reducer';
import DriverReducer from './Driver/reducer';

//begin containers
import StartQuoteContainer from './StartQuote/StartQuoteContainer';
import ConfirmationContainer from './Confirm/ConfirmContainer';
import ReviewContainer from './Review/ReviewContainer';
import EndQuoteContainer from './EndQuote/EndQuoteContainer';
import DriverContainer from './Driver';
import VehicleContainer from './Vehicle';
import HistoryContainer from './History';
import QuoteReviewContainer from './QuoteReview';

//import components
import PageShell from './Shared/PageShell';
import FooterComponent from './Shared/FooterComponent';
import Navigation from './Navigation';
import LoadingComponent from './LoadingComponent';
import ModalMessageComponent from './ModalMessage';

import { emptyToken, sessionTimedOut } from './StartQuote/actions';

const reducer = combineReducers({
  quoteStart: StartQuoteReducer,
  userConfirmation: ConfirmationReducer,
  form: FormReducer,
  ReviewReducer,
  sectionTitleReducer,
  LoadingReducer,
  DriverReducer
});



const store = createStore(
  reducer,
  applyMiddleware(thunk, logger));


class App extends Component {

  componentDidMount(){
    this.counter();
  }

  counter(){
    setTimeout(()=>{      
      store.dispatch(emptyToken());
      store.dispatch(sessionTimedOut());
    }, 
    60 * 60000
    );
  }


  render() {
    //const {sessionTimeOut} = store.getState().quoteStart;
    
    return (
      <Provider store={store}>
        <HashRouter>
          <div>                        
           <Navigation logo={logo} />
            <div className="container">
              <div className="rower">
                <LoadingComponent />
                <ModalMessageComponent />
                <Route exact path="/" component={PageShell(StartQuoteContainer)} />
                <Route path="/confirm" component={PageShell(ConfirmationContainer)} />
                <Route path="/driver/:id" component={PageShell(DriverContainer)} />
                <Route path="/vehicle/:id" component={PageShell(VehicleContainer)} />
                <Route path="/history" component={PageShell(HistoryContainer)} />
                <Route path="/review" component={PageShell(ReviewContainer)} />
                <Route path="/quote" component={PageShell(EndQuoteContainer)} />
                <Route path="/endquote" component={PageShell(QuoteReviewContainer)} />

              </div>
            </div>
            <FooterComponent companyName="Verisk Analytics" />
          </div>

        </HashRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js